import enUS from "./en-US.json";
import ru from "./ru.json";
import uzCyrl from "./uz-Cyrl.json";
import uzLatn from "./uz-Latn.json";

// Each file is a complete schema.org FAQPage document. The FAQ page renders
// its questions and answers as well, so the visible text and the JSON-LD in
// <head> come from one source and cannot drift apart.

interface FaqPageSchema {
  "@context": string;
  "@type": string;
  inLanguage: string;
  url: string;
  mainEntity: {
    "@type": string;
    name: string;
    acceptedAnswer: { "@type": string; text: string };
  }[];
}

const faqPages: Record<string, FaqPageSchema> = {
  "uz-Latn": uzLatn,
  "uz-Cyrl": uzCyrl,
  ru,
  "en-US": enUS,
};

export function getFaqPage(lang: string): FaqPageSchema {
  return faqPages[lang] || faqPages["uz-Latn"];
}

// Anchor ids come from the Uzbek Latin questions, so all languages share them
// and the existing /faq#... links keep working.
export const faqIds = uzLatn.mainEntity.map((q) =>
  q.name
    .toLowerCase()
    .replace(/['ʻʼ‘’`.]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, ""),
);

export function faqJsonLdScript(lang: string) {
  return {
    type: "application/ld+json",
    // "<" is escaped so the answer HTML can never close the script tag early
    children: JSON.stringify(getFaqPage(lang)).replace(/</g, "\\u003c"),
  };
}
